<article class="card-wrapper" *ngLet="langChange$ | async">
  <header class="card-header">
    <div class="svg32 mr4 white-color">
      <div class="svg32" *ngIf="data.imageCategory" [innerHTML]="data.imageCategory ?? '' | safeHTML"></div>
    </div>
    <span class="caption-4 card-title">{{ data.title }}</span>
  </header>

  <main class="card-body h4">
    <div *ngIf="data?.text?.length">
      <div [matTooltip]="data.text">{{ data.text }}</div>
    </div>
  </main>

  <footer class="card-footer">
    <div class="stats">
      <app-rating [rating]="data.rating" [isNew]="data.isNew" [isMobileRating]="true" [smallIcons]="true" [hasNotRating]="clickable"></app-rating>
      <div class="views ml12" *ngIf="!hasShowDownloads">
        <svg [icon]="icons.Viewed18" class="svg18 inactive-color mr4" />
        <span class="views-amount">{{ data.views }}</span>
      </div>

      <div class="views ml12" *ngIf="hasShowDownloads">
        <svg [icon]="icons.Downloaded18" class="svg18 inactive-color mr4" />
        <span class="views-amount">{{ data.downloads }}</span>
      </div>

      <div class="ml4 during_week">
        <span class="caption-4"> {{ 'OTHER.DURING_WEEK' | translate }}</span>
      </div>
    </div>
    <a [routerLink]="[route]" [queryParams]="{ isDynamic: data.isDynamic }" class="link-5 catalog-link" (click)="$event.stopPropagation()">
      <span class="link-5 mr4">{{ 'OTHER.TO_DATASET' | translate }}</span>
      <svg [icon]="icons.ArrowRight" class="svg18" />
    </a>
  </footer>
</article>
